import { NavLink, useLocation } from 'react-router-dom';
import { Home, Clock, Briefcase, DollarSign, CalendarClock } from 'lucide-react';
import { useLanguageStore } from '../store/languageStore';
import translations from '../translations';

export function Navigation() {
  const handleNavClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const { language } = useLanguageStore();
  const t = translations[language];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-light-card dark:bg-dark-card border-t border-light-border dark:border-dark-border shadow-lg">
      <div className="max-w-lg mx-auto flex">
        <NavLink
          to="/"
          onClick={handleNavClick}
          className={({ isActive }) =>
            `flex-1 py-4 flex flex-col items-center gap-1 transition-colors ${
              isActive 
                ? 'text-primary-600 bg-primary-50 dark:bg-primary-900/20' 
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-dark-border'
            }`
          }
        >
          <Home className="h-6 w-6" />
          <span className="text-sm font-medium">{t.menu.home}</span>
        </NavLink>
        <NavLink
          to="/time"
          onClick={handleNavClick}
          className={({ isActive }) =>
            `flex-1 py-4 flex flex-col items-center gap-1 transition-colors ${
              isActive 
                ? 'text-primary-600 bg-primary-50 dark:bg-primary-900/20' 
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-dark-border'
            }`
          }
        >
          <Clock className="h-6 w-6" />
          <span className="text-sm font-medium">{t.menu.clock}</span>
        </NavLink>
        <NavLink
          to="/work-orders"
          onClick={handleNavClick}
          className={({ isActive }) =>
            `flex-1 py-4 flex flex-col items-center gap-1 transition-colors ${
              isActive 
                ? 'text-primary-600 bg-primary-50 dark:bg-primary-900/20' 
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-dark-border'
            }`
          }
        >
          <Briefcase className="h-6 w-6" />
          <span className="text-sm font-medium">{t.menu.orders}</span>
        </NavLink>
        <NavLink
          to="/expenses"
          onClick={handleNavClick}
          className={({ isActive }) =>
            `flex-1 py-4 flex flex-col items-center gap-1 transition-colors ${
              isActive 
                ? 'text-primary-600 bg-primary-50 dark:bg-primary-900/20' 
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-dark-border'
            }`
          }
        >
          <DollarSign className="h-6 w-6" />
          <span className="text-sm font-medium">{t.menu.expenses}</span>
        </NavLink>
        <NavLink
          to="/shifts"
          onClick={handleNavClick}
          className={({ isActive }) =>
            `flex-1 py-4 flex flex-col items-center gap-1 transition-colors ${
              isActive 
                ? 'text-primary-600 bg-primary-50 dark:bg-primary-900/20' 
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200 hover:bg-gray-50 dark:hover:bg-dark-border'
            }`
          }
        >
          <CalendarClock className="h-6 w-6" />
          <span className="text-sm font-medium">{t.menu.shifts}</span>
        </NavLink>
      </div>
    </div>
  );
}